// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:OqJqVo */\n.PwoKW{align-items:center;display:inline-flex;gap:var(--audio-spacing-16)}.LR4hq{height:1.125rem;width:1.125rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "PwoKW",
	"icon": "LR4hq"
};
export default ___CSS_LOADER_EXPORT___;
